import { lazy, useRef } from "react"
import { useTranslation } from "react-i18next"

import { isTornOutDocument } from "@/App/TearOutSection/tornOutDocument"
import { RegionWrapper } from "@/components/layout/Region"
import { Loader } from "@/components/Loader"
import { analytics$ } from "@/services/analytics"
import { join } from "@/utils/join"
import { useHasItBeenVisible } from "@/utils/useHasItBeenVisible"

const AnalyticsCore = lazy(() => import("./AnalyticsCore"))

analytics$.subscribe()

const LoaderComponent = () => {
  const { t } = useTranslation()
  return (
    <Loader
      ariaLabel={t("analytics.loadingPriceAndTradeAnalytics")}
      minWidth="320px"
    />
  )
}

export const Analytics = ({
  hideBelowMd = false,
}: {
  hideBelowMd?: boolean
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const shouldMountAnalytics = useHasItBeenVisible(ref)

  return (
    <RegionWrapper
      ref={ref}
      className={join(
        "border-l-(length:--spacing-sm) border-solid border-(--bg-primary)",
        !isTornOutDocument && hideBelowMd && "max-[750px]:hidden",
      )}
      fallback={<LoaderComponent />}
    >
      {shouldMountAnalytics ? (
        <AnalyticsCore>
          <LoaderComponent />
        </AnalyticsCore>
      ) : (
        <LoaderComponent />
      )}
    </RegionWrapper>
  )
}

export default Analytics
